import loader from '@monaco-editor/loader';

/** Matches the `monaco-editor` pin in `package.json`. `monacoLoader.architecture.test.ts` fails when they differ. */
export const MONACO_EDITOR_VERSION = '0.58.0-dev-20261104';

/**
 * Loads Monaco from the CDN release that matches the installed `monaco-editor`. The
 * loader's built-in default is an older release that bundles a vulnerable DOMPurify,
 * and `npm audit` checks only the installed version.
 */
export function configureMonacoLoader(): void {
  loader.config({
    paths: { vs: `https://cdn.jsdelivr.net/npm/monaco-editor@${MONACO_EDITOR_VERSION}/min/vs` }
  });
}
